<template>
  <div class="section-report">
    <Wrapper title="新开户统计">
      <template #header>
        <el-row>
          <el-col :span="12">
            <CheckTab
              :option="tabs"
              :active.sync="actTab"
              @change="onExTab"
            />
          </el-col>
          <el-col
            :span="12"
            style="text-align: right;"
          >
            <DatePicker @pick="pickDate" />
          </el-col>
        </el-row>
      </template>
      <template #content>
        <div class="box">
          <div class="chart">
            <div
              ref="chartblock"
              style="height: 500px"
            />
          </div>
          <div class="table">
            <el-table
              :data="ranklist"
              style="width: 100%"
              :cell-class-name="setTableCellClass"
              header-row-class-name="table-header"
            >
              <el-table-column
                label="排名"
                width="100px"
              >
                <template slot-scope="scope">
                  <span
                    class="table-index"
                    :style="makeTableRankStyles(scope.$index)"
                  >
                    {{ scope.$index + 1 }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="product_name"
                label="合作产品"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.product_name || '--' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="company"
                label="广告主公司名称"
              >
                <template slot-scope="scope">
                  <a
                    style="text-decoration: none; cursor: pointer; color: #2F9EFF"
                    @click="toDetail(scope.row.customer_id)"
                  >
                    {{ scope.row.company || '--' }}
                  </a>
                </template>
              </el-table-column>
              <el-table-column
                prop="total"
                label="消耗"
              >
                <template slot-scope="scope">
                  <span>¥{{ scope.row.total || '--' }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>
    </Wrapper>
  </div>
</template>

<script>
import accounting from 'accounting';
import echarts from 'echarts';
import { basePileBarOption } from '../echartConfig';
import roma from '../echartConfig/roma.json';
import $util from '@/common/js/util';
import Request from '@/core/QuRequest';
import rank1 from '@/assets/image/rank/rank_1.png';
import rank2 from '@/assets/image/rank/rank_2.png';
import rank3 from '@/assets/image/rank/rank_3.png';
import Wrapper from '../components/Wrapper';
import CheckTab from '../components/CheckTab';
import DatePicker from '../components/DatePicker';

const req = new Request();

// tab
const ExTabs = {
  customer: {
    id: 'customer',
    text: '消耗波动',
    ct: '新开户消耗汇总',
    yLab: '¥{value}',
  },
  category: {
    id: 'category',
    text: '按行业看客户数',
    ct: '按行业看客户数',
    yLab: '{value} 个',
  },
  arpu: { id: 'arpu', text: 'ARPU', ct: 'ARPU', yLab: '¥{value}' },
};

export default {
  name: 'SectionClient',
  components: {
    Wrapper,
    CheckTab,
    DatePicker,
  },
  data() {
    return {
      // 列表序号样式
      rank: {
        rank1,
        rank2,
        rank3,
      },

      // pick date
      date: '',
      timeDuration: [],

      // tab
      actTab: ExTabs['customer'].id,
      tabs: Object.values(ExTabs),

      // chart
      option: {
        ...basePileBarOption,
      },
      customerSlice: [],
      categorySlice: [],
      arpuSlice: [],

      // table
      ranklist: [],
    };
  },

  created() {
    echarts.registerTheme('roma', roma);
    this._fetchClientData();
  },

  mounted() {
    this.reInitEchart();
    window.addEventListener('resize', this.onClientChartResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onClientChartResize);
  },

  methods: {
    // table 序号样式
    makeTableRankStyles(i) {
      if (i < 3) {
        let res = {
          color: '#fff',
          background: '',
          width: '26px',
          height: '26px',
          marginLeft: '-4px',
        };
        const t = this.rank[`rank${i + 1}`];
        res.background = `url(${t}) no-repeat center center / 72%`;
        return res;
      }
      return {};
    },

    // 设置列样式
    setTableCellClass({ columnIndex }) {
      if (columnIndex === 2) {
        return 'table-cell-prod';
      }
    },

    // 获取数据
    async _fetchClientData() {
      if (!this.date) return;
      try {
        const params = {
          date: this.date,
        };
        const res = await req.send(
          req.Apis.sales.report.dataCustomerNew,
          params,
        );
        this.regroupChartData(res.data);
        setTimeout(() => {
          this.onExTab(this.actTab);
        });
        this.ranklist = res.data.list;
      } catch (err) {
        this.$message.error(`获取新开户数据失败：${err.message || '未知错误'}`);
      }
    },

    // 选择日期
    pickDate({ duration = [] } = {}) {
      this.timeDuration = duration;
      this.date = duration[0] + ',' + duration[duration.length - 1];
      this._fetchClientData();
    },

    // todo: 切换tab执行dispose和init，是兼容arpu既有叠加图又有折线图的情况
    reInitEchart() {
      this.clientCharts = echarts.dispose(this.$refs['chartblock'], 'roma');
      this.clientCharts = echarts.init(this.$refs['chartblock'], 'roma');
    },

    // 切换tab
    onExTab(id = '') {
      const tabMap = ExTabs[id] || {};
      this.reInitEchart(); // reset
      this.clientCharts.off('legendToggleSelect', 'series', handleLegendToggle);

      this.option.title.text = tabMap.ct;
      this.option.xAxis = {
        type: 'category',
        data: this.timeDuration,
      };
      this.option.yAxis.axisLabel = { formatter: tabMap.yLab };
      this.option.series = this[`${id}Slice`].map((item, index) => {
        item.type = 'bar';
        item.barWidth = '50%';
        item.stack = '总量';
        return item;
      });
      this.option.dataZoom = [
        {
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          start: 1,
          end: 100,
        },
      ];

      if (id === ExTabs.customer.id) {
        this.option.title.text += `：¥${accounting.formatNumber(
          this.calTotal(this.customerSlice),
          2,
        )}`;
      }

      if (id === ExTabs.arpu.id) {
        // 折线图数据
        this.option.series.push({
          name: '平均ARPU',
          type: 'line',
          yAxisIndex: 0,
          data: calARPULineData(this.arpuSlice),
        });
        this.clientCharts.on(
          'legendselectchanged',
          'series',
          handleLegendToggle.bind(this),
        );
      }
      this.clientCharts.setOption(this.option);

      // 监听lengend选择事件
      function handleLegendToggle(e) {
        // eslint-disable-next-line no-invalid-this
        this.arpuSlice.forEach((i) => {
          if (i.name === e.name) {
            // 更新标记位
            i.__hide = !e.selected[e.name];
          }
        });
        // eslint-disable-next-line no-invalid-this
        this.option.series[
          // eslint-disable-next-line no-invalid-this
          this.option.series.length - 1
          // eslint-disable-next-line no-invalid-this
        ].data = calARPULineData(this.arpuSlice);
        // eslint-disable-next-line no-invalid-this
        this.clientCharts.setOption(this.option);
      }
    },

    // 计算和
    calTotal(data = []) {
      return data.reduce((dr, dv) => {
        return dr + (dv.data || []).reduce((r, v) => r + Number(v || 0), 0);
      }, 0);
    },

    // 重组数据
    regroupChartData(data) {
      let chart = data.chart;
      this.customerSlice = this.matchSeriesData(
        'customer',
        this.timeDuration,
        chart,
      );
      this.categorySlice = this.matchSeriesData(
        'cateGory',
        this.timeDuration,
        chart,
      );
      this.arpuSlice = this.matchSeriesData('arpu', this.timeDuration, chart);
    },

    // 匹配数据
    matchSeriesData(type = 'cateGory', date = [], ori = {}) {
      let res = []; // [{ name: '', data: [] }]
      const existInx = (name = '') => res.findIndex((i) => i.name === name);
      const defArr = Array(date.length).fill(null);

      Object.entries(ori).forEach(([k, v]) => {
        const dateInx = date.indexOf(k);
        Object.entries(v[type] || {}).forEach(([tk, tv]) => {
          let item;
          const inx = existInx(tk);
          if (inx > -1) {
            res[inx].data[dateInx] = tv;
          } else {
            item = {
              __hide: false, // 标记位，用于级联控制数据显示(ARPU)
              name: tk,
              data: [...defArr],
            };
            item.data.splice(dateInx, 1, tv);
            res.push(item);
          }
        });
      });
      return res;
    },

    // on resize
    onClientChartResize() {
      this.clientCharts && this.clientCharts.resize();
    },

    // 跳转广告主详情
    toDetail(id) {
      if (!id) return;
      let url = '/advertiser-manage/detail';
      url += `?id=${id}`;
      $util.openUrl(url, { newWin: true });
    },
  },
};

// 计算ARPU 折线数据
function calARPULineData(arpu = []) {
  // 过滤ARPU显示数据
  const list = arpu.filter((i) => !i.__hide) || [];
  const { length } = (list[0] || {}).data || [];
  return Array.from({ length }).map((v, i) => {
    return (
      list.reduce((res, pv, pi) => {
        return res + (((pv || {}).data || [])[i] || 0);
      }, 0) / list.length
    ).toFixed(2);
  });
}
</script>

<style lang="less" scoped>
.section-report {
  .table {
    padding-top: 48px;
    overflow: hidden;

    /deep/ .el-table th {
      padding: 12px 0;
    }

    /deep/ .el-table td {
      padding: 12px 0;

      &.table-cell-prod {
        color: #2f9eff;
      }
    }

    /deep/ .table-header {
      background: #fafafa;
      border-radius: 4px 4px 0px 0px;

      th {
        background: transparent;
        color: #303133;
        font-size: 14px;
        font-weight: 500;
      }
    }

    .table-index {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #f0f2f5;
      margin-right: 24px;
      font-size: 12px;
      font-family: HelveticaNeue-Medium;
      font-weight: 500;
      color: rgba(96, 98, 102, 1);
    }
  }
}
</style>
